import { Routes, Route } from "react-router-dom";
import Layout from "..//pages/layout/layout";

import About from "../pages/about";
import Previlages from "../pages/auth//screens/Previlages/Prevelages";
import Offer from "../pages/auth/screens/offer/offer";
import MyAccount from "../pages/auth/screens/My-Account/MyAccount";
import Savings from "../pages/auth/screens/Savings/Savings";
import Orders from "../pages/auth/screens/Orders/Orders";
import TermsAndCondition from "../pages/TermAndCondition/TermsAndCondition";
import Faqs from "../pages/faqs/faqs";
import ContectUs from "../pages/contect-us/contect-us";
import OrderHistory from "../pages/order-history";
import Profile from "../pages/profile";
import { routerPath } from "./path";
import Home from "../pages/auth/screens/home";
import ClaimOffer from "../pages/auth/screens/claim-offer/claim-offer";
import YourOffers from "../pages/auth/screens/YourOffers/YourOffers";

const AuthRoutes = () => {
	return (
		<Routes>
			<Route path={routerPath.home} element={<Home />}></Route>
			<Route path={routerPath.about} element={<About />}></Route>
			<Route path={routerPath.offer} element={<Offer />}></Route>
			<Route path={routerPath.previlages} element={<Previlages />}></Route>
			<Route path={routerPath.yourOffers} element={<YourOffers />}></Route>
			<Route path={routerPath.claimOffer} element={<ClaimOffer />}></Route>
			<Route path={routerPath.faqs} element={<Faqs />}></Route>
			<Route
				path={routerPath.termsandcondition}
				element={<TermsAndCondition />}></Route>
			<Route path={routerPath.contectUs} element={<ContectUs />}></Route>
			<Route path={routerPath.profile} element={<Profile />}></Route>
			<Route path={routerPath.orderHistory} element={<OrderHistory />}></Route>
			<Route path={routerPath.myAccount} element={<MyAccount />}></Route>
			<Route path={routerPath.orders} element={<Orders />}></Route>
			<Route path={routerPath.savings} element={<Savings />}></Route>
			<Route path="/*" element={<Home />}></Route>
		</Routes>
	);
};

export default AuthRoutes;
